module.exports = "/images/CreateAssign.svg";